// src/components/LoadingModal.jsx

import { useState, useEffect } from 'react';

export default function LoadingModal({ isOpen, onComplete }) {
  const steps = [
    'Computing means test',
    'Performing liquidation analysis',
    'Computing disposable income',
    'Determining dischargeability',
  ];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!isOpen) return;
    setCurrent(0);
    const interval = setInterval(() => {
      setCurrent(prev => {
        if (prev < steps.length - 1) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setTimeout(onComplete, 500); // slight pause on last
          return prev;
        }
      });
    }, 1800);
    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center space-y-4">
        {/* Spinner */}
        <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
        {/* Only the current step */}
        <p className="text-center text-indigo-600 font-semibold animate-pulse">
          {steps[current]}…
        </p>
      </div>
    </div>
  );
}